import React, { Component } from 'react'
import { connect } from 'react-redux'
import SavingAdminParam from "./SavingAdminParam"
import AdminBuyProcDelvy from "./AdminBuyProcDelvy"

class SavingAdmin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            readOnly : props.user.userprofile.Roles[0].indexOf("Admin") > -1 ? false : true
        }
    }

    render() {
        return (            
            <div>
                <SavingAdminParam readOnly={this.state.readOnly}></SavingAdminParam>
                <br></br> 
                <AdminBuyProcDelvy readOnly={this.state.readOnly}></AdminBuyProcDelvy>               
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.default
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SavingAdmin)